import { goToLink } from "@actions/common";
import { showAlert as showAlertAction } from "@components/alert/action";
import playIcon from "@layouts/assets/images/play_icon.svg";
import { openGame } from "@pages/casino/utils";
import {
	getBettoGameCardAspectRatio,
	getImageSrc,
	handleBettoGameImageError,
} from "@pages/home/betto/casinoGridSlider/gameCard.jsx";
import { getBettoImageLoadingProps } from "@pages/home/betto/utils";
import {
	CardGameName,
	CardHoverOverlay,
	CardImage,
	CardPlayIcon,
} from "@pages/home/betto/casinoSlider/elements";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import { BettoExploreGameCardWrap } from "./elements";

export const BettoExploreGameCard = ({ game, onClose, imageIndex }) => {
	const dispatch = useDispatch();
	const imageLoadingProps = getBettoImageLoadingProps(imageIndex);

	const handleClick = useCallback(() => {
		const redirect = (...args) => dispatch(goToLink(...args));
		const showAlert = (...args) => dispatch(showAlertAction(...args));

		const { pathname, search } = window.location;
		localStorage.setItem("casino.basePath", `${pathname}${search}`);
		openGame(game, redirect, showAlert);
		onClose?.();

		window?.dataLayer?.push({
			event: "casino-game-card-click",
			gameName: game?.remote_name,
			gameId: game?.game_id,
			gameAffiliate: game?.affiliate,
			gameProvider: game?.provider,
			is_live: game?.is_live,
		});
	}, [game, dispatch, onClose]);

	const handleImageError = useCallback(
		(event) => {
			handleBettoGameImageError(event, game);
		},
		[game]
	);

	return (
		<BettoExploreGameCardWrap
			data-testid={`button-game-card-${game?.remote_name}`}
			$aspectRatio={getBettoGameCardAspectRatio(game)}
			onClick={handleClick}>
			<CardImage
				src={getImageSrc(game)}
				alt={game?.remote_name || ""}
				{...imageLoadingProps}
				onError={handleImageError}
			/>
			<CardHoverOverlay onClick={handleClick}>
				<CardGameName>{game?.remote_name}</CardGameName>
				<CardPlayIcon
					src={playIcon}
					alt=""
				/>
			</CardHoverOverlay>
		</BettoExploreGameCardWrap>
	);
};
